import {
  MainContentArea,
  PageContentWrapper,
  PageTitle,
} from "melco-ui";
import { DisplayStatistics } from "../../components/reporting/statistics/DisplayStatistics";
import { useTranslation } from "react-i18next";

export const Statistics: React.FC = () => {
  const { t } = useTranslation()
  return (
    <MainContentArea contentPadding>
      <PageContentWrapper>
        <PageTitle>{t('main_menu.reporting')}</PageTitle>
        {/* <FullWidthSpace
          direction="vertical"
          size="small"
          data-cy-id="dashboard-statistics"
        > */}
        <DisplayStatistics />
        {/* </FullWidthSpace> */}
      </PageContentWrapper>
    </MainContentArea>
  );
};
